export default function() {
    const forms = [...document.querySelectorAll(".form")];
    forms.forEach(form => {
        form.addEventListener("freeform-ready", function(event) {
            const freeform = event.target.freeform;
            freeform.setOption("renderSuccess", function() {
                let form = this.form;
                let parent = form.parentNode;
                let msg = parent.querySelector(".form__success");
                msg.style.display = "block";
                parent.removeChild(form);
            });
        });
    });
}
